import {customElement, LitElement, property, html as _} from "lit-element";
import UiBaseStyles from "@kta20-ui-base/resources/styles";
import {INBOX} from "@kta20-ui-base/resources/icons";

@customElement(UiNoRecords.TAG_NAME)
export class UiNoRecords extends LitElement {

    static TAG_NAME = 'kta20-ui-no-records'

    @property({ type: String })
    title:string;

    @property({ type: String })
    text:string;

    protected render() {
        return _`
            <style>${UiBaseStyles}</style>
            <div class="kta20-align-middle-center" style="height: 300px; max-width: 70%">
                <ion-icon src="data:image/svg+xml;charset=utf-8,${INBOX}" 
                        style="font-size: 128px; color: lightgray"></ion-icon>
                <h4 style="color: gray">${this.title}</h4>
                <p style="color: gray">${this.text}</p>
            </div>
        `;
    }
}
